import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
export default function ProtectedRoute() {
  const LoggedIn = localStorage.getItem("UserLoggedIn");
  return LoggedIn? <Outlet/> : <Navigate to={'/'}/>;
}
